/** Счета Telegram Stars. */
import { Empty } from "../errors";
import type { EndpointDef } from "../endpoint";
import { Product } from "../../monetization";
import { z } from "zod";

/** Счёт Telegram Stars: ссылка для `Telegram.WebApp.openInvoice`. Цену задаёт сервер. */
export const CreateInvoiceRequest = z.object({ product: Product });

export const CreateInvoiceResponse = z.object({ url: z.url() });

export const paymentEndpoints = {
  /** Выписать счёт Telegram Stars. */
  createInvoice: {
    method: "POST",
    path: "/api/payments/invoice",
    request: CreateInvoiceRequest,
    response: CreateInvoiceResponse,
    auth: true,
  },
  /** Стартовый пакет показан: больше его не предлагаем (MADR 0014). */
  starterSeen: { method: "POST", path: "/api/payments/starter-seen", request: Empty, response: Empty, auth: true },
} as const satisfies Record<string, EndpointDef>;
